import ENV from '@/config/runtime-env'

export const API_CONFIG = {
  baseURL: ENV.apiBaseUrl,
  timeout: ENV.apiTimeout,
  endpoints: {
    test: '/api/test',
  },
}

export default API_CONFIG
